export const APP_CONFIG = {
  INSTITUTION_NAME: 'FRAC Grand Large',
  START_DATE: '2026-01-24',
  END_DATE: '2026-08-30',
  DEFAULT_LANGUAGE: 'fr' as const,

  // Timing settings (in seconds)
  THANK_YOU_DURATION: 20,
  IDLE_TIMEOUT: 60, // 1 min before the overlay shows
  IDLE_COUNTDOWN_DURATION: 120, // 2 minutes countdown when idle overlay appears

  // Results slideshow timing
  RESULTS_BASE_DURATION: 7, // Base 7 seconds per slide
  RESULTS_CTA_DURATION: 5, // 5 seconds for call-to-action slides
  RESULTS_CTA_INTERVAL: 20, // Show CTA every N questions
  RESULTS_WORD_THRESHOLD: 20, // Start adding time after this many words
  RESULTS_MS_PER_WORD: 200, // Milliseconds to add per word above threshold

  // Design tokens
  COLORS: {
    ACCENT: '#77bacd',
  },

  // Typography tokens
  TYPOGRAPHY: {
    HEADLINE: '-apple-system-headline',
    SUBHEADLINE: '-apple-system-subheadline',
    CAPTION: '-apple-system-caption1',
    BUTTON: '-apple-system-short-body',
  },
} as const;
